"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _shopList = require("@/api/shop/shopList");
var _invoice = require("@/api/invoice/invoice");
var _download = require("@/api/invoice/download");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 水波纹指令

var orderTypeOptions = [{
  key: 1,
  value: "点餐订单"
}, {
  key: 2,
  value: "虚拟订单"
}, {
  key: 3,
  value: "储值订单"
}, {
  key: 4,
  value: "预约订单"
}];
var orderTypeKeyValue = orderTypeOptions.reduce(function (acc, cur) {
  acc[cur.key] = cur.value;
  return acc;
}, {});
var statusOptions = [{
  key: 0,
  value: "申请中"
}, {
  key: 1,
  value: "已审核"
}, {
  key: 2,
  value: "已开具"
}, {
  key: 3,
  value: "已冲红"
}];
var statusKeyValue = statusOptions.reduce(function (acc, cur) {
  acc[cur.key] = cur.value;
  return acc;
}, {});
var _default = exports.default = {
  name: "goodsManage",
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  filters: {
    orderTypeFilter: function orderTypeFilter(key) {
      return orderTypeKeyValue[key];
    },
    statusFilter: function statusFilter(key) {
      return statusKeyValue[key];
    }
  },
  data: function data() {
    return {
      tableKey: 0,
      dataList: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: null,
        orderSn: null,
        invoiceReqSn: null,
        redInvoiceReqSn: null,
        redFlag: null,
        invoiceNo: null,
        status: null
      },
      resPath: process.env.VUE_IMAGE_PATH,
      shopList: [],
      // 订单号弹窗相关
      orderListDialogVisible: false,
      orderSnList: [],
      // 下载相关
      downloadingRow: null
    };
  },
  created: function created() {
    this.getList();
    // getshopList().then(res => {
    //   if (res) {
    //     this.shopList = res.records;
    //   }
    // });
  },
  computed: {},
  methods: {
    handleClickTab: function handleClickTab(tab, event) {
      this.handleFilter();
    },
    openEditInTab: function openEditInTab(row) {
      this.$emit("open-edit", {
        id: row.orderId,
        title: "\u8BE6\u60C5 - ".concat(row.orderSn)
      });
    },
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _invoice.queryBluePage)(this.listQuery).then(function (response) {
        if (response) {
          _this.dataList = response.records;
          _this.total = response.total;
        }
        setTimeout(function () {
          _this.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      //查询
      this.listQuery.page = 1;
      this.getList();
    },
    retPage: function retPage() {
      //分页
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.listQuery.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.listQuery.limit = size;
      this.listQuery.page = 1;
      this.getList();
    },
    // 显示订单号列表
    showOrderList: function showOrderList(orderSns) {
      if (orderSns) {
        this.orderSnList = orderSns.split(",");
        this.orderListDialogVisible = true;
      }
    },
    // 处理下载
    handleDownload: function handleDownload(row, ext) {
      var _this2 = this;
      try {
        // 解析 ext 字段中的 JSON
        var extData = typeof ext === "string" ? JSON.parse(ext) : ext;
        if (extData && extData.download_url) {
          // 设置下载状态
          this.downloadingRow = row.invoiceId;

          // 基础下载方式 - 直接跳转
          window.open(extData.download_url, "_self");
          this.$message.success("开始下载...");

          // 重置下载状态
          setTimeout(function () {
            _this2.downloadingRow = null;
          }, 1000);
        } else {
          this.$message.error("下载地址不存在");
        }
      } catch (error) {
        console.error("下载失败:", error);
        this.$message.error("下载失败，请稍后重试");
        this.downloadingRow = null;
      }
    }
  }
};